import ImageLogo from "@/assets/images/logo.png";
import LoginVideo from "@/assets/video/login-background.mp4";
import { ROUTE_HOME, ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { sendRefreshTokens } from "@/models/socket/authenticate.model";
import {
  isTokenExpired,
  setLSAuthToken,
  setLSRefreshToken,
} from "@/utils/tokens.util";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const PageLoggingIn: React.FC = () => {
  const { jwt } = useParams();
  const navigate = useNavigate();

  // Attempt to get the JWT from the URL
  useEffect(() => {
    console.log("JWT from URL: ", jwt);
    if (!jwt) {
      //after 3 seconds, redirect to login
      setTimeout(() => {
        navigate(ROUTE_LOGIN_OUT);
      }, 3000);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (jwt) {
        if (isTokenExpired(jwt)) {
          console.log("jwt is expired");
          navigate(ROUTE_LOGIN_OUT);
        } else {
          console.log("jwt is valid", jwt);
          const loginResult = await sendRefreshTokens(jwt);
          console.log("loginResult: ", loginResult);
          if (loginResult.rStatus) {
            if (loginResult.rStatus === "error") {
              console.log("jwt is expired");
              navigate(ROUTE_LOGIN_OUT);
            } else {
              console.log("jwt is valid");
              // Save the auth and refresh token to local storage
              setLSAuthToken(loginResult.rData.authToken);
              setLSRefreshToken(loginResult.rData.refreshToken);
              navigate(ROUTE_HOME);
            }
          } else {
            console.error(
              "Logging-In attempt failed to get a valid response format"
            );
            navigate(ROUTE_LOGIN_OUT);
          }
        }
      } else {
        console.log("jwt is expired or missing");
        navigate(ROUTE_LOGIN_OUT);
      }
    };
    fetchData();
  }, []);

  const projectName = import.meta.env.VITE_PROJECT_DISPLAY_NAME;
  return (
    <div className="bg-neutral-900">
      <video
        src={LoginVideo}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="fixed top-0 left-0 z-0 h-full w-full object-cover opacity-30"
      ></video>
      <div className="fixed top-2 left-2 flex h-24 items-center">
        <img src={ImageLogo} alt="Logo" className="h-full object-contain" />
        {projectName && (
          <div className="ml-4 text-2xl font-bold text-white sm:text-4xl md:text-5xl">
            {projectName}
          </div>
        )}
      </div>
      <div>
        <div className="flex h-screen items-center justify-center">
          <div className="h-32 w-32 animate-spin rounded-full border-b-6 border-white"></div>
        </div>
        <div className="flex h-screen items-center justify-center">
          <div className="h-32 w-32 animate-spin rounded-full border-b-6 border-white"></div>
        </div>
        <div className="fixed inset-0 flex items-center justify-center">
          <h2 className="text-xl text-white">Logging in...</h2>
        </div>
      </div>
    </div>
  );
};
export default PageLoggingIn;
